var map = {
	"./android.svg": "b2fa",
	"./apple.svg": "990a",
	"./banktransfer.svg": "7e0f",
	"./bitcoin.svg": "a881",
	"./de-flag.png": "37d5",
	"./ecopayz.svg": "826b",
	"./ezeewallet.svg": "fc00",
	"./flexepin.svg": "71df",
	"./ga-grey.svg": "5bfc",
	"./ga.svg": "07ae",
	"./gambling-therapy.svg": "d808",
	"./gameanon.svg": "c48b",
	"./gamecare.svg": "e554",
	"./header-bg-mobile.png": "f406",
	"./header-bg.png": "206d",
	"./ic_18plus.svg": "1ebb",
	"./ic_ssl.svg": "a2f6",
	"./iterac.svg": "3cc0",
	"./kahnawake.png": "958f",
	"./logo-mini.svg": "0df4",
	"./logo.svg": "e347",
	"./mastercard.svg": "2dac",
	"./mga.svg": "96f9",
	"./muchbetter.svg": "e075",
	"./neosurf.svg": "3cf1",
	"./neteller.svg": "50f8",
	"./oldman.png": "d516",
	"./one.svg": "fc11",
	"./paysafecard.svg": "444a",
	"./skrill.svg": "19cf",
	"./sofort.svg": "4427",
	"./three.svg": "9ce7",
	"./two.svg": "3456",
	"./visa.svg": "f73a",
	"./youngman.png": "2f1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";